<template>
  <div>
    <h2>点评智能分析编辑</h2>
    <el-card class="box-card">
      <el-card>
        <div slot="header" class="clearfix">
          <span>信息</span>
        </div>
         <div class="text item">
          <el-row :gutter="24">
            <el-col :span="8">
              <em class="font">产品：</em>{{detail.PRODUCTNAME}}
            </el-col>
            <el-col :span="8">
              类别：{{detail.CATEGORYNAME}}
            </el-col>
            <el-col :span="8">
              厂商简称：{{detail.FACTORYNAME}}
            </el-col>
          </el-row>
          <el-row>
           <el-col :span="8">
              优点：{{detail.advantages}}
            </el-col>
            <el-col :span="8">
              不足：{{detail.disadvantages}}
            </el-col>
            <el-col :span="8">
              时间：{{detail.lastoperationtime}}
            </el-col>
          </el-row>
          <el-row>
           <el-col :span="8">
              综合评分：{{detail.ztgsnum}}
            </el-col>
            <el-col :span="8">
              建议提醒：{{detail.aftersales}}
            </el-col>
          </el-row>
        </div>
      </el-card>
      <el-card>
        <div
          slot="header"
          class="clearfix"
        >
          <h3>功能分析</h3>
        </div>
        <h4>优点中提到的功能</h4>
        <el-row :gutter="20">
          <!-- 智能分享 -->
          <el-col :span="16">
            <el-tag
              v-for="tag in suporiority"
              :key="tag.id"
              closable
              @close="handleClose(tag)"
            >
              {{tag.function_title}}
            </el-tag>
          </el-col>
          <!-- 录入关键词 -->
          <el-col :span="6">
            <div>
              <el-select
              v-model="inputValue"
              filterable
              ref="selectCh"
              placeholder="请选择所属维度分类"
              @change="searchSelect"
            >
              <el-option
                v-for="item in listG"
                :key="item.id"
                :label="item.title"
                :value="`${item.id},${item.title}`"
              >{{item.title}}
              </el-option>
            </el-select>
            </div>

          </el-col>
          <el-col :span="2">
            <el-button
              class="button-new-tag"
              type="primary"
              @click="addItem()"
            >添加</el-button>
          </el-col>
        </el-row>
        <h4>不足中提到的功能</h4>
        <el-row :gutter="20">
          <!-- 智能分享 -->
          <el-col :span="16">
            <el-tag
              v-for="tag in suporiority2"
              :key="tag"
              closable
              @close="handleClose2(tag)"
            >
              {{tag.function_title}}
            </el-tag>
          </el-col>
          <!-- 录入关键词 -->
          <el-col :span="6">
            <el-select
              v-model="inputValue2"
              filterable
              @change="searchSelect2"
              placeholder="请选择所属维度分类"

            >
              <el-option
                v-for="item in listG"
                :key="item.id"
                :label="item.title"
                :value="`${item.id},${item.title}`"
              >{{item.title}}
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              class="button-new-tag"
              type="primary"
              @click="addItem2()"
            >添加</el-button>
          </el-col>
        </el-row>

      </el-card>

      <el-card style="margin:40px 0 0 0 ">
        <div
          slot="header"
          class="clearfix"
        >
          <h3>其他维度分析</h3>
        </div>
        <h4>优点中提到的维度</h4>
        <el-row :gutter="20">
          <!-- 智能分享 -->
          <el-col :span="16">
            <el-tag
              v-for="tag in suporiority3"
              :key="tag"
              closable
              @close="handleClose3(tag)"
            >
              {{tag.dimension_title}}
            </el-tag>
          </el-col>
          <!-- 录入关键词 -->
          <el-col :span="6">
            <el-select
              v-model="inputValue3"
              filterable
              @change="searchSelect3"
              placeholder="请选择所属维度分类"
            >
              <el-option
                v-for="item in listAll"
                :key="item.id"
                :label="item.title"
                :value="`${item.id},${item.title}`"
              >{{item.title}}
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              class="button-new-tag"
              type="primary"
              @click="addItem3"
            >添加</el-button>
          </el-col>
        </el-row>
        <h4>不足中提到的维度</h4>
        <el-row :gutter="20">
          <!-- 智能分享 -->
          <el-col :span="16">
            <el-tag
              v-for="(tag,index) in suporiority4"
              :key="index"
              closable
              @close="handleClose4(tag)"
            >
              {{tag.dimension_title}}
            </el-tag>
          </el-col>
          <!-- 录入关键词 -->
          <el-col :span="6">
            <el-select
              v-model="inputValue4"
              filterable
              @change="searchSelect4"
              placeholder="请选择所属维度分类"
            >
              <el-option
                v-for="item in listAll"
                :key="item.id"
                :label="item.title"
                :value="`${item.id},${item.title}`"

              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              class="button-new-tag"
              type="primary"
              @click="addItem4"
            >添加</el-button>
          </el-col>
        </el-row>

      </el-card>

      <el-button type="primary" style="margin:20px;width:250px" @click="addAll()">保存</el-button>


    </el-card>
  </div>

</template>
<script>
import axios from 'axios'
export default {
  name: 'ReviewItem',
  props: ['reviewId', 'reviewStatus'],
  data () {
    return {
      step: 1,
      detail: null,
      title: '',
      suporiority: {},
      suporiority2: {},
      suporiority3: {},
      suporiority4: {},
      inputValue: '',
      inputValue2: '',
      inputValue3: '',
      inputValue4: '',
      inputVisible: '',
      listG: [],
      listAll: [],
      label1: '',
      label2: '',
      label3: '',
      label4: '',
      value1: '',
      value2: '',
      value3: '',
      value4: ''

    }
  },
  methods: {
    // 获取详情
    getDetail () {
      let url = `${this.$config.API.reviews.detail}/${this.reviewId}`
      axios.get(url)
        .then(res => {
          if (res.status === 200) {
            this.detail = res.data.transmitObj
          }
        })
    },
    searchSelect (val) {
      let [value, label] = val.split(',')
      this.label1 = label
      this.value1 = value
    },
    searchSelect2 (val) {
      let [value, label] = val.split(',')
      this.label2 = label
      this.value2 = value
    },
    searchSelect3 (val) {
      let [value, label] = val.split(',')
      this.label3 = label
      this.value3 = value
    },
    searchSelect4 (val) {
      let [value, label] = val.split(',')
      this.label4 = label
      this.value4 = value
    },
    // 确认输入tag标签
    handleInputConfirm () {
      let url = this.$config.API.reviews.capacityFind
      let params = {
        score_id: this.reviewId
      }
      axios.get(url, { params }).then(res => {
        this.listG = res.data.functionList
      })
      this.inputVisible = true

      this.inputVisible = false
      this.inputValue = ''
    },
    handleInputConfirm3 () {
      let inputValue = this.inputValue4
      console.log('inputValue4:', inputValue)
      let url = this.$config.API.reviews.acapacityAlList
      axios.get(url).then(res => {
        this.listAll = res.data.dimensionList
        inputValue = {
          title: this.inputValue4
        }
        if (inputValue !== '') {
          console.log('suporiority3:', this.suporiority3)
          this.suporiority3.push(inputValue)
        }
      })
      inputValue = {
        title: inputValue
      }
      this.inputVisible = false
      this.inputValue4 = ''
    },
    // 删除tag标签
    handleClose (tag) {
      this.suporiority.splice(this.suporiority.indexOf(tag), 1)
    },
    handleClose2 (tag) {
      this.suporiority2.splice(this.suporiority2.indexOf(tag), 1)
    },
    handleClose3 (tag) {
      this.suporiority3.splice(this.suporiority3.indexOf(tag), 1)
    },
    handleClose4 (tag) {
      this.suporiority4.splice(this.suporiority4.indexOf(tag), 1)
    },
    // 显示tag标签
    addItem () {
      this.inputVisible = true
      this.inputValue = {
        type: '1',
        function_id: this.value1,
        function_title: this.label1
      }
      if (this.inputValue !== '') {
        this.suporiority.push(this.inputValue)
      }
      this.inputValue = ''
    },
    addItem2 () {
      this.inputVisible = true
      this.inputValue2 = {
        type: '2',
        function_id: this.value2,
        function_title: this.label2
      }
      if (this.inputValue2 !== '') {
        this.suporiority2.push(this.inputValue2)
      }
      this.inputValue2 = ''
    },
    addItem3 () {
      this.inputVisible = true
      this.inputValue3 = {
        type: '1',
        dimension_id: this.value3,
        dimension_title: this.label3
      }
      if (this.inputValue3 !== '') {
        this.suporiority3.push(this.inputValue3)
      }
      this.inputValue3 = ''
    },
    addItem4 () {
      this.inputVisible = true
      this.inputValue4 = {
        type: '2',
        dimension_id: this.value4,
        dimension_title: this.label4
      }
      if (this.inputValue4 !== '') {
        this.suporiority4.push(this.inputValue4)
      }
      this.inputValue4 = ''
    },
    addAll () {
      let url = this.$config.API.reviews.capacityAdd
      var obj1 = this.suporiority
      var obj2 = this.suporiority2
      let functionArray = obj1.concat(obj2)

      var obj3 = this.suporiority3
      var obj4 = this.suporiority4
      let dimensionArray = obj3.concat(obj4)

      let data = {
        score_id: this.reviewId,
        dimension_array: dimensionArray,
        function_array: functionArray
      }
      axios.post(url, data).then(res => {
        this.$message.success('保存成功')
      })
    },
    // 智能分析功能列表根据id查询
    fetchData () {
      let url = this.$config.API.reviews.AlListDetail
      let params = {
        score_id: this.reviewId
      }
      axios.get(url, { params }).then(res => {
        // 功能优点
        this.suporiority = res.data.yd_functionList
        // 功能缺点
        this.suporiority2 = res.data.qd_functionList
        // 维度优点
        this.suporiority3 = res.data.yd_dimensionList.map((item) => {
          item.type = 1
          return item
        })
        // 维度缺点
        // this.suporiority4 = res.data.qd_dimensionList
        this.suporiority4 = res.data.qd_dimensionList.map((item) => {
          item.type = 2
          return item
        })
      })
    }
  },
  mounted () {
    this.handleInputConfirm()
    this.handleInputConfirm3()
    this.fetchData()
    this.getDetail()
  }
}
</script>

<style lang="sass" scoped>
.el-steps
  width: 50%
  margin: 20px auto
</style>
<style>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

</style>






// WEBPACK FOOTER //
// Smart.vue?5fa2c2de